<label for="{{id}}" class="app-component-container"
  [ngClass]="{'size-sm': size.toLowerCase()=='sm', 'size-md': size.toLowerCase()=='md', 'size-lg': size.toLowerCase()=='lg'}">
  <div class="border-silver app-radio-containter rouded border"
  [ngClass]="{'bg-light': disabled, 'bg-white': !disabled, 'focus': focus && outline}">
    <i class="mdi mdi-circle {{color}}" [ngClass]="{'checked': checked, 'unchecked': !checked, 'disabled text-muted': disabled}"></i>
  </div>
  <div class="pl-3 input-radio-label" *ngIf="label!=''" [ngClass]="{'text-muted': disabled}">
    {{label}}
  </div>
  <input (change)="change()"
  [(ngModel)]="model"
  [value]="value"
  [disabled]="disabled"
  (focus)="focus=true"
  (blur)="focus=false"
  type="radio"
  id="{{id}}"
  name="{{id}}"
  >
</label>
